<h2 mat-dialog-title>Linking Patreon Failed</h2>
<mat-dialog-content>
    <div style="display: flex; justify-content: center; align-items: center; gap: 50px; margin: 2rem 0 3rem 0">
        <img src="/img/jar.png" alt="Jar" style="width: 100px; height: 100px;">
        <app-icon icon="error" style="font-size: 50px;"></app-icon>
        
        <picture>
            <source srcset="/img/patreon_icon_dark.svg" media="(prefers-color-scheme: dark)">
            <img src="/img/patreon_icon.svg" alt="Patreon" style="width: 100px; height: 100px;">
        </picture>
    </div>
    <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button style="width: fit-content;" mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>